import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import benefits from './benefits.json';
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../store";
import {Router} from "@angular/router";

interface ILimitedOfferBenefit {
  title: string;
  subList: string[];
}

@Component({
    selector: 'db-anniversary-offer-banner',
    templateUrl: './anniversary-offer-banner.component.html',
    styleUrls: ['./anniversary-offer-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AnniversaryOfferBannerComponent implements OnInit {

  @Input() isFreePlan = false;
  @Input() countdown: number;
  @Input() countDownUnit: string;
  @Input() hoursLeft: number;
  @Input() endDate: number;
  @Input() startDate: number;
  @Output() onClose = new EventEmitter<void>();
  @Output() onSendGAEvent = new EventEmitter<string>();
  public benefits: ILimitedOfferBenefit[] = benefits as any;
  public endDateInHours: any;
  public scoreInHours: any;

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _router: Router,
  ) { }

  ngOnInit() {
    if (!this.startDate) {
      this.startDate = new Date().getTime();
    }
    this.endDateInHours = this.endDate && this.startDate && Math.floor((this.endDate - this.startDate) / 60 / 60 / 1000);
    if (this.countDownUnit === 'd') {
      this.scoreInHours = this.hoursLeft && this.hoursLeft * 24;
    }
    this.onSendGAEvent.emit('Banner view');
  }

  public claimOffer(): void {
    this.onSendGAEvent.emit('Claim offer button');
    this.onClose.emit();
    this._router.navigate(['/upgrade-plan']);
  }

  public openChat(): void {
    window['Smooch']?.open();
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }

}
